import { Outlet } from 'react-router';

import { AuthLayout } from '@/layouts/auth-layout';

const AuthRoot = () => {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default AuthRoot;
